// components/LogEntry.tsx

import React from 'react';
import eventRenderers from './Events/eventRenderers';
import { GameLog } from '../../../Logs/LogsDisplay';

interface LogEntryProps {
  log: GameLog;
}

const LogEntry: React.FC<LogEntryProps> = ({ log }) => {
  // Define ignored event types to ensure they are not rendered here
  const ignoredEventTypes = ['DamageDealt'];

  // Skip rendering if the event type is in the ignored list
  if (ignoredEventTypes.includes(log.type)) {
    return null; // Do not render this event
  }

  // Determine the appropriate renderer for the event type
  const Renderer = eventRenderers[log.type] || eventRenderers['Default'];

  return (
    <div className="log-entry">
      <Renderer log={log} />
      {/* No rendering of child events to prevent accidental stack update rendering */}
    </div>
  );
};

export default LogEntry;
